import { ModelState } from "../../interfaces/modelState";
import { Validators } from "./validator/validators";

export default function unobtrusiveValidation<T>(
  validators: Validators<T> | undefined,
  modelState: ModelState | null | undefined,
  propertyName: string | undefined,
  input: T
) {
  let validatorCopy = validators;
  let modelStateCopy = modelState;

  if (validatorCopy === undefined) {
    validatorCopy = [];
  }

  if (typeof validatorCopy === "function") {
    validatorCopy = [validatorCopy];
  }

  if (!modelStateCopy) {
    modelStateCopy = {};
  }

  if (!propertyName) {
    return modelStateCopy;
  }

  const propertyExistsInModelState = Object.keys(modelStateCopy).find(
    (key) => key.toLowerCase() === propertyName.toLowerCase()
  );

  if (propertyExistsInModelState) {
    // Reset modelstate case insensitive
    delete modelStateCopy[propertyExistsInModelState];
  }

  for (const validator of validatorCopy) {
    // Execute the validators in a chain
    if (typeof validator === "function") {
      const message = validator(input);
      if (message) {
        modelStateCopy[propertyName] = [message];
        return modelStateCopy;
      }
    }
  }
  // reset the property messages to blank
  modelStateCopy[propertyName] = [];
  return modelStateCopy;
}
